<template>
    <v-layout column>
        <v-layout justify-center>
            <h1>Contractor Export</h1>
        </v-layout>
        <v-form v-model="exportForm">
            <v-layout row wrap>
                <v-flex xs12>
                    <v-autocomplete
                        label="Contractor Organisation"
                        v-model="contractorOrganisationID"
                        :items="availableContractorOrganisations"
                        clearable
                        :rules="[required]"
                    ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6>
                    <date-picker ref="startDate"
                        label="Start Date"
                        :value="startDate"
                        @input="updateStartDate"
                        :rules="[required, beforeEndDate]">
                    </date-picker>
                </v-flex>
                <v-flex xs12 sm6>
                    <date-picker ref="endDate"
                        label="End Date"
                        :value="endDate"
                        @input="updateEndDate"
                        :rules="[required, afterStartDate]">
                    </date-picker>
                </v-flex>
            </v-layout>
        </v-form>
        <v-layout>
            <v-btn color="success" :loading="exportLoading" :disabled="!exportForm" @click="exportCSV">Export CSV</v-btn>
        </v-layout>
    </v-layout>
</template>

<script>
import DatePicker from '@/components/generic/DatePicker.vue';

export default {
    components: {
        DatePicker
    },
    props: [
        'contractorOrganisations'
    ],
    data() {
        return {
            exportForm: false,
            contractorOrganisationID: null,
            startDate: new Date(),
            endDate: new Date(),
            exportLoading: false
        }
    },
    computed: {
        availableContractorOrganisations(){
            return this.contractorOrganisations.map(x => {
                return {
                    text: x.Name,
                    value: x.ContractorOrganisationID
                };
            });
        }
    },
    methods: {
        required(v){
            if(v == null){
                return "Required";
            }

            return false;
        },
        updateStartDate(v){
            this.startDate = v;
            this.$refs.endDate.validate();
        },
        beforeEndDate(v){
            if(v == null || this.endDate == null){
                return false;
            }

            if(this.endDate < v){
                return "Must be before start date";
            }

            return false;
        },
        updateEndDate(v){
            this.endDate = v;
            this.$refs.startDate.validate();
        },
        afterStartDate(v){
            if(v == null || this.startDate == null){
                return false;
            }

            if(v < this.startDate){
                return "Must be after end date";
            }

            return false;
        },
        async exportCSV(){
            this.exportLoading = true;

            try {
                await this.$store.dispatch("PrecedaStore/downloadContractorExport", {
                    contractorOrganisationID: this.contractorOrganisationID,
                    startDate: this.startDate,
                    endDate: this.endDate,
                });
            } catch(err){
                this.showExportError();
            }

            this.exportLoading = false;
        },
        showExportError(){
            alert("Unable to export");
        }
    },
    created() {

    }
}
</script>
